import httpClient from '@/api/http-client';

const endpoint = 'api/zones';

const zonesService = {
  getPage: (params) => httpClient.get(endpoint, { params }),

  getById: (id) => httpClient.get(`${endpoint}/${id}`),

  search: (search) => httpClient.post(`${endpoint}/find`, { search }),

  create: (zone) => httpClient.post(`${endpoint}`, zone),

  update: (zone) => httpClient.put(`${endpoint}/${zone.id}`, zone),

  delete: (zone) => httpClient.delete(`${endpoint}/${zone.id}`),
};

export default zonesService;
